@if (viewCount) {
  <span class="view-count-text">Viewed {{ viewCount }} times this week.</span>
}

